<template>
	<div class="redo" :style="`background-image: url(${assetPath}lockup-backgrounds/redo-left.png), url(${assetPath}lockup-backgrounds/redo-right.png), url(${this.assetPath}lockup-backgrounds/speckled-surface.jpg);`">
		<div>
			<button class="button button--green" type="button" v-if="persona !== 'economist'" @click="setPersona('economist')">See Economist Results</button>
			<button class="button button--green" type="button" v-if="persona !== 'never-settler'" @click="setPersona('never-settler')">See Never Settler Results</button>
			<button class="button button--green" type="button" v-if="persona !== 'busy-bee'" @click="setPersona('busy-bee')">See Busy Bee Results</button>
			<button class="button button--green" type="button" @click="retakeQuiz">Retake Quiz</button>
		</div>
	</div>
</template>

<script>
import { assetPath } from './../mixins/assetPath.js'
import { pageMode } from './../mixins/pageMode.js'

// import zenscroll from 'zenscroll'

// const body = document.querySelector('body')

export default {
	name: 'Redo',
	mixins: [assetPath, pageMode],
	computed: {
		persona() {
			return this.$store.state.results.personaCalculated
		}
	},
	methods: {
		scrollToTop() {
			console.log('scrollToTop', window, window.scrollY)
			if (typeof window !== 'undefined') {
				window.setTimeout(() => {
					window.scroll({
						top: 0,
						left: 0,
						behavior: 'auto',
					});
				}, 100)
			}
		},
		retakeQuiz() {
			this.$store.dispatch('resetQuiz')
			this.scrollToTop()
			if (typeof dataLayer === 'object') {
				// eslint-disable-next-line
				dataLayer.push({
					event: 'genericEvent',
					eventCat: 'OCS Engagement',
					eventAction: 'click',
					eventLabel: 'Retake Quiz',
				});
			}
		},
		setPersona(per) {
			// console.log('setPersona', per)
			this.$store.dispatch('forcePersona', { personaCalculated: per })
			this.$emit('getProducts')
			this.scrollToTop()			
			if (typeof dataLayer === 'object') {
				// eslint-disable-next-line
				dataLayer.push({
					event: 'genericEvent',
					eventCat: 'OCS Engagement',
					eventAction: 'click',
					eventLabel: 'Force Persona | ' + per,
				});
			}
		}
	},
}
</script>

<style lang="scss">
.redo {
	background-repeat: no-repeat;
	background-position: -9000px -9000px, -9000px -9000px, center center;
	background-size: contain, contain, cover;
	padding: 10vw 1em;
	& > div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 1em;
		button {
			width: 100%;
		}
	}
	@include breakpoint(large) {
		background-position: left top, right top, center center;
		& > div {
			flex-direction: row;
			max-width: 788px;
			margin: 0 auto;
		}
		button {
			flex: 0 0 calc(33.333% - 0.666em);
		}
	}
}
</style>
